import { applicationCurrentApplicationSelector, useReduxSelector } from '@applyboard/ab-common';
import useApplicationAsSnapshot from "./useApplicationAsSnapshot";
var useCurrentApplicationAsSnapshot = function useCurrentApplicationAsSnapshot() {
  var applicationData = useReduxSelector(applicationCurrentApplicationSelector);
  return useApplicationAsSnapshot(applicationData);
};
export default useCurrentApplicationAsSnapshot;